import "./Icon.css"

export default {
	name: "eiis-icon",
	props: ['name', 'type', 'size', 'tooltip'],
	data: function () {
		return {
			styles: function () {
				return {
					cursor: 'pointer',
					marginLeft: '6px'
				}
			}
		}
	},
	template: `
	<div class="icon" v-bind:id=name
		v-bind:class="[type, size]"
		v-bind:title=tooltip
		v-bind:style="styles"
		v-bind:aria-describedby={name}
	  >
	</div>
  `
}
